import MerchandisingContentServiceClient from './MerchandisingContentService';
import TenantRegistryService from './TenantRegistryService';

const merchandisingContentServiceClient = new MerchandisingContentServiceClient();
const tenantRegistryService = new TenantRegistryService();

const FALLBACK_DOMAIN = 'www.vistaprint.com';

export const getTenant = async (space: string): Promise<string | null> => {
  try {
    const spaces = await merchandisingContentServiceClient.getSpaces();

    if (spaces[space]) {
      return spaces[space].tenant;
    }

    return null;
  } catch (error) {
    console.error('Error fetching tenant for space', { space, error });
    return null;
  }
};

export async function getTenantDomain(tenant: string, locale: string): Promise<string> {
  try {
    const { domain } = await tenantRegistryService.resolveTenant(tenant, locale);
    return domain;
  } catch (error) {
    console.error(`TenantProvider: error fetching domain for ${tenant}/${locale}`, error);
    return FALLBACK_DOMAIN;
  }
}
